import React from 'react';
import { Input } from '@/components/Input';
import { FormField } from '@/components/FormField';
import { Card, SectionHeader } from '@/components/Card';
import { AlignEndHorizontal } from 'lucide-react';

export const FooterEditor: React.FC<{ value?: string; onChange: (next: string) => void }> = ({ value, onChange }) => (
  <Card padded={false} className="overflow-hidden">
    <div className="border-b border-border px-5 py-4">
      <SectionHeader
        title="Footer"
        subtitle="Optional, ≤ 60 chars. No variables. Often used for an opt-out hint."
        icon={<AlignEndHorizontal size={15} />}
        className="mb-0"
      />
    </div>
    <div className="px-5 py-4">
      <FormField label="Footer text" hint={`${(value ?? '').length} / 60`}>
        <Input
          value={value ?? ''}
          maxLength={60}
          onChange={(e) => onChange(e.target.value)}
          placeholder="Reply STOP to opt out"
        />
      </FormField>
    </div>
  </Card>
);
